import React, { useEffect } from 'react';
import Header from '../components/marketing/Header';
import Footer from '../components/marketing/Footer';
import TalkToAlfred from '../components/TalkToAlfred';

// Dedicated "Talk to Alfred" page — a clean destination for ad CTAs.
export default function DemoPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-6">
          <TalkToAlfred />
        </div>
      </section>
      <Footer />
    </div>
  );
}
